export enum KeyboardKeyEnum {
    BackSpace = "Backspace",
    Tab = "Tab",
    Enter = "Enter",
    ShiftLeft = "ShiftLeft",          
    CtrlLeft = "ControlLeft",       
    AltLeft = "AltLeft",    
    ShiftRight = "ShiftRight",          
    CtrlRight = "ControlRight",       
    AltRight = "AltRight",                
    PauseBreak = "Pause",
    CapsLock = "CapsLock",
    Escape = "Escape",
    PageUp = "PageUp",
    Space = "Space",
    PageDown = "PageDown",
    End = "End",
    Home = "Home",

    Left = "ArrowLeft",
    Up = "ArrowUp",
    Right = "ArrowRight",
    Down = "ArrowDown",

    PrintScreen = "PrintScreen",
    Insert = "Insert",
    Delete = "Delete",

    key0 = "Digit0",
    Key1 = "Digit1",
    Key2 = "Digit2",
    Key3 = "Digit3",
    Key4 = "Digit4",
    Key5 = "Digit5",
    Key6 = "Digit6",
    Key7 = "Digit7",
    Key8 = "Digit8",
    Key9 = "Digit9",

    A = "KeyA",
    B = "KeyB",
    C = "KeyC",
    D = "KeyD",
    E = "KeyE",
    F = "KeyF",
    G = "KeyG",
    H = "KeyH",
    I = "KeyI",
    J = "KeyJ",
    K = "KeyK",
    L = "KeyL",
    M = "KeyM",
    N = "KeyN",
    O = "KeyO",
    P = "KeyP",
    Q = "KeyQ",
    R = "KeyR",
    S = "KeyS",
    T = "KeyT",
    U = "KeyU",
    V = "KeyV",
    W = "KeyW",
    X = "KeyX",
    Y = "KeyY",
    Z = "KeyZ",

    LeftWindowKey = "MetaLeft",
    RightWindowKey = "MetaRight",
    SelectKey = "ContextMenu",

    Numpad0 = "Numpad0",
    Numpad1 = "Numpad1",
    Numpad2 = "Numpad2",
    Numpad3 = "Numpad3",
    Numpad4 = "Numpad4",
    Numpad5 = "Numpad5",
    Numpad6 = "Numpad6",
    Numpad7 = "Numpad7",
    Numpad8 = "Numpad8",
    Numpad9 = "Numpad9",

    Multiply = "NumpadMultiply",
    Add = "NumpadAdd",
    Subtract = "NumpadSubtract",
    DecimalPoint = "NumpadDecimal",
    Devide = "NumpadDivide",

    F1 = "F1",
    F2 = "F2",
    F3 = "F3",
    F4 = "F4",
    F5 = "F5",
    F6 = "F6",
    F7 = "F7",
    F8 = "F8",
    F9 = "F9",
    F10 = "F10",
    F11 = "F11",
    F12 = "F12",

    NumLock = "NumLock",
    ScrollLock = "ScrollLock",

    Multimedia_MyComputer = "LaunchMyComputer",
    Multimedia_MyCalculator = "LaunchCalculator",

    SemiColon = "Semicolon",
    EqualSign = "Equal",
    Comma = "Comma",
    Dash = "Minus",
    Period = "Period",
    ForwardSlash = "Slash",
    OpenBracket = "BracketLeft",
    BackSlash = "Backslash",
    CloseBracket = "BracketRight",
    SingleQuote = "Quote",
    NumpadEnter = "NumpadEnter",
    NumpadAdd = "NumpadAdd",
    NumpadMultiply = "NumpadMultiply",
    NumpadDivide = "NumpadDivide",
    NumpadSubtract = "NumpadSubtract",
    NumpadDecimal = "NumpadDecimal",
    Minus = "Minus",
    Equal = "Equal",
    BracketLeft = "BracketLeft",
    BracketRight = "BracketRight",
    Backslash = "Backslash",
    Semicolon = "Semicolon",
    Quote = "Quote", 
    Slash = "Slash",
    Backquote = "Backquote", 
 
}

export type KeyboardKey = `${KeyboardKeyEnum}`;

//export type"Backspace" | "Tab" | "Enter" | "ShiftLeft" | "ControlLeft" | "AltLeft" | "Pause" | "CapsLock" | "Escape" | "PageUp" | "Space" | "PageDown" | "End" | "Home" | "ArrowLeft" | "ArrowUp" | "ArrowRight" | "ArrowDown" | "PrintScreen" | "Insert" | "Delete" | "Digit0" | "Digit1" | "Digit2" | "Digit3" | "Digit4" | "Digit5" | "Digit6" | "Digit7" | "Digit8" | "Digit9" | "KeyA" | "KeyB" | "KeyC" | "KeyD" | "KeyE" | "KeyF" | "KeyG" | "KeyH" | "KeyI" | "KeyJ" | "KeyK" | "KeyL" | "KeyM" | "KeyN" | "KeyO" | "KeyP" | "KeyQ" | "KeyR" | "KeyS" | "KeyT" | "KeyU" | "KeyV" | "KeyW" | "KeyX" | "KeyY" | "KeyZ" | "MetaLeft" | "MetaRight" | "ContextMenu" | "Numpad0" | "Numpad1" | "Numpad2" | "Numpad3" | "Numpad4" | "Numpad5" | "Numpad6" | "Numpad7" | "Numpad8" | "Numpad9" | "NumpadMultiply" | "NumpadAdd" | "NumpadSubtract" | "NumpadDecimal" | "NumpadDivide" | "F1" | "F2" | "F3" | "F4" | "F5" | "F6" | "F7" | "F8" | "F9" | "F10" | "F11" | "F12" | "NumLock" | "ScrollLock" | "LaunchMyComputer" | "LaunchCalculator" | "Semicolon" | "Equal" | "Comma" | "Minus" | "Period" | "Slash" | "BracketLeft" | "Backslash" | "BracketRight" | "Quote";
